import { Field as ChakraField } from '@chakra-ui/react';
import { InputNumber, InputNumberProps } from '@components/ui/input/InputNumber';
import RequiredIndicator from '@components/ui/RequiredIndicator';
import { hasChanged, isInvalid } from '@utils/validation/validation.utils';
import { Field, useFormikContext } from 'formik';
import { FormattedMessage } from 'react-intl';

import ModifiedTag from './ModifiedField';

type FormInputNumberProps = {
  label: string;
  i18nKey?: string;
  required?: boolean;
} & InputNumberProps;

export function FormInputNumber<T extends object>({
  label,
  i18nKey,
  required = true,
  min = 0,
  ...rest
}: Readonly<FormInputNumberProps>) {
  const { initialValues, touched, errors, values, setFieldValue } = useFormikContext<T>();

  return (
    <ChakraField.Root
      variant="cockpit"
      required={required}
      invalid={required ? isInvalid(label, touched, errors) : false}
    >
      <ChakraField.Label width="100%" height="20px">
        <FormattedMessage id={i18nKey ?? `components.sensorInstallation.form.common.${label}`} />
        <RequiredIndicator />
        {hasChanged(label, initialValues, values) && <ModifiedTag />}
      </ChakraField.Label>
      <Field
        as={InputNumber}
        type="text"
        name={label}
        id={label}
        min={min}
        onChange={(value?: number) => setFieldValue(label, value ?? null)}
        {...rest}
      />
    </ChakraField.Root>
  );
}
